import React from 'react';
import {useLocation} from 'react-router-dom';

import {Header} from '../../../components/Layout';
import * as routePaths from '../../../consts/route/routePaths';

const HIDDEN_HEADER_ROUTES = [routePaths.AGE_GATE, routePaths.APP_LOCKED];

const AppHeader = (props) => {
    const {pathname} = useLocation();
    const isHeaderHidden = HIDDEN_HEADER_ROUTES.some((route) => route === pathname);

    return isHeaderHidden ? null : <Header {...props} />;
};

export default AppHeader;
